// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://plizcqmxjmtzdgmmhtxj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBsaXpjcW14am10emRnbW1odHhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA1OTQyNzMsImV4cCI6MjA1NjE3MDI3M30.72HJ2aUyWbqjKcvsTm1BdRldWaEd5bcPYzgF5fnYXCs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});